// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vbt-autcomplete-list[data-v-a0e87de4]{padding-top:5px;position:absolute;max-height:350px;overflow-y:auto;z-index:999}", ""]);
// Exports
module.exports = exports;
